import { Table } from 'antd';
import React from 'react';
import './SummaryTotalRow.css';

interface SummaryTotalRowProps {
  getTotalPriceWithAdition: () => number;
  getTotalAchizitionPrice: () => number;
  isMobile?: boolean;
}

const SummaryTotalRow: React.FC<SummaryTotalRowProps> = ({
  getTotalPriceWithAdition,
  getTotalAchizitionPrice,
  isMobile = false,
}) => {
  if (isMobile) {
    return (
      <div className='mobile-summary-row'>
        <div className='mobile-summary-item'>
          <span className='mobile-summary-label'>Total Achizitie:</span>
          <span className='mobile-summary-value'>{getTotalAchizitionPrice()} Ron</span>
        </div>
        <div className='mobile-summary-item'>
          <span className='mobile-summary-label'>Total cu Adaos:</span>
          <span className='mobile-summary-value'>{getTotalPriceWithAdition()} Ron</span>
        </div>
      </div>
    );
  }

  return (
    <Table.Summary.Row className='summary-total-row'>
      <Table.Summary.Cell index={0}>
        <strong>Total:</strong>
      </Table.Summary.Cell>
      <Table.Summary.Cell index={1} />
      <Table.Summary.Cell index={2} />
      <Table.Summary.Cell index={3} />
      <Table.Summary.Cell index={4} />
      <Table.Summary.Cell index={5} />
      <Table.Summary.Cell index={6} />
      <Table.Summary.Cell index={7} />
      <Table.Summary.Cell index={8} />
      <Table.Summary.Cell index={9} />
      <Table.Summary.Cell index={10}>
        <strong className='acquisition-total'>{getTotalAchizitionPrice()} Ron</strong>
      </Table.Summary.Cell>
      <Table.Summary.Cell index={11}>
        <strong className='price-with-addition-total'>{getTotalPriceWithAdition()} Ron</strong>
      </Table.Summary.Cell>
      <Table.Summary.Cell index={12} />
    </Table.Summary.Row>
  );
};

export default SummaryTotalRow;
